import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import axios from "axios";

const CONTACT_CENTER_BASE_URL = "/api/comisiones-contact-center";

export const getSupervisorContactCenter = (): IAction => {
  return {
    type: actionTypes.GET_SUPERVISOR_CONTACT_CENTER,
    payload: axios.get(
      `${constants.BASE_URL}${CONTACT_CENTER_BASE_URL}/supervisor-contact-center`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getOperadorContactCenter = (): IAction => {
  return {
    type: actionTypes.GET_OPERADOR_CONTACT_CENTER,
    payload: axios.get(
      `${constants.BASE_URL}${CONTACT_CENTER_BASE_URL}/chater-contact-center`,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const postContactCenter = (data: any): IAction => {
  return {
    type: actionTypes.POST_CONTACT_CENTER,
    payload: axios.post(
      `${constants.BASE_URL}${CONTACT_CENTER_BASE_URL}/contact-center`,
      data,
      {
        withCredentials: true
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};
